<template>
  <div class="main">
    <MyHeader index="2"></MyHeader>
    <div class="titleIfo">
      <div class="container" v-if="this.$i18n.locale == 'zh_CN'">
        <h2>合作伙伴</h2>
        <h3>Partners</h3>
      </div>
      <div class="container" v-if="this.$i18n.locale == 'en_US'">
        <h2>Partners</h2>
        <h3>合作伙伴</h3>
      </div>
    </div>
    <div class="partnersUsInfo">
      <div class="container">
      
            
			 <nav aria-label="Breadcrumb" class="breadcrumb2">
			  <ul>
				<li><a href="/">{{ $t("header.home") }}</a> </li>
				<li><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></li>
				<li><span aria-current="page">{{ $t("header.partners") }}</span></li>
			  </ul>
			</nav>
			
        <div class="content">
        
          <div class="leftMenu">
            <ul>
              <li class="on">
                <router-link to="partner">
                  <i>{{ $t("partner.tit") }}</i>
                  <b></b>
                </router-link>
              </li>
              <li>
                <router-link to="partners">
                  <i>{{ $t("partner.tit1") }}</i>
                  <b></b>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="rightContent">
            <div class="titleNav">
              <ul id="navTab">
                <li class="on">{{ $t("cooperation.tit") }}</li>
                <li>{{ $t("cooperation.tit1") }}</li>
                <li>{{ $t("cooperation.tit2") }}</li>
                <li>{{ $t("cooperation.tit3") }}</li>
              </ul>
            </div>
            <div class="logoList">
              <ul class="listItems" v-if="this.$i18n.locale == 'zh_CN'">
                <li v-for="(item, index) in PartnerList">
                  <a :href="item.website">
                    <img :src="item.logo" :alt="item.name" />
                  </a>
                  <div>
                    <a :href="item.website"> {{ item.name }} </a>
                  </div>
                </li>
              </ul>
              <ul class="listItems" v-if="this.$i18n.locale == 'en_US'">
                <li v-for="(item, index) in PartnerList">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  /></a>
                  <div>
                    <a :href="item.website"> {{ item.name_en }} </a>
                  </div>
                </li>
              </ul>

              <ul  class="listItems" v-if="this.$i18n.locale == 'zh_CN'">
                <li v-for="(item, index) in PartnerList2">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  /></a>
                  <div>
                    <a :href="item.website"> {{ item.name }} </a>
                  </div>
                </li>
              </ul>
              <ul  class="listItems" v-if="this.$i18n.locale == 'en_US'">
                <li v-for="(item, index) in PartnerList2">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  /></a>
                  <div>
                    <a :href="item.website"> {{ item.name_en }} </a>
                  </div>
                </li>
              </ul>

              <ul  class="listItems" v-if="this.$i18n.locale == 'zh_CN'">
                <li v-for="(item, index) in PartnerList3">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  /></a>
                  <div>
                    <a :href="item.website"> {{ item.name }} </a>
                  </div>
                </li>
              </ul>
              <ul  class="listItems" v-if="this.$i18n.locale == 'en_US'">
                <li v-for="(item, index) in PartnerList3">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  /></a>
                  <div>
                    <a :href="item.website"> {{ item.name_en }} </a>
                  </div>
                </li>
              </ul>

              <ul  class="listItems" v-if="this.$i18n.locale == 'zh_CN'">
                <li v-for="(item, index) in PartnerList4">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  /></a>
                  <div>
                    <a :href="item.website"> {{ item.name }} </a>
                  </div>
                </li>
              </ul>
              <ul  class="listItems" v-if="this.$i18n.locale == 'en_US'">
                <li v-for="(item, index) in PartnerList4">
                  <a :href="item.website"
                    ><img :src="item.logo" :alt="item.name"
                  />
                  <div>
                    <a :href="item.website"> {{ item.name_en }} </a>
                  </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>

<script>
import {
  createPartner,
  getPartnerList,
  getPartnerDetails,
  deletePartner,
  putPartner,
} from "@/services/partner";
import MyHeader from "./common/MyHeader";
import MyFooter from "./common/MyFooter";
export default {
  name: "PartnerPage",
  components: { MyHeader, MyFooter },
  data() {
    return {
      totalCount: 0,
      PartnerList: [],
      PartnerList2: [],
      PartnerList3: [],
      PartnerList4: [],

      search: {
        is_admin: 1,
        page: 1,
        search_str: "",
      },
    };
  },
  mounted() {
    $(".listItems").eq(0).show().siblings().hide();
    this.navTabClickEvent();
    this.getList();
  },

  methods: {
    navTabClickEvent() {
      $("#navTab li").on("click", function () {
        $(this).addClass("on").siblings().removeClass("on");
        let index = $(this).index();
       
       $(".listItems").eq(index).show().siblings().hide();
       	
      });
    },
    getList() {
      getPartnerList(this.search)
        .then((res) => {
          let list = res.items;
          for (var i in list) {
            var item = list[i];
            if (item.type == 1) {
              this.PartnerList.push(item);
            }
            if (item.type == 2) {
              this.PartnerList2.push(item);
            }
            if (item.type == 3) {
              this.PartnerList3.push(item);
            }
            if (item.type == 4) {
              this.PartnerList4.push(item);
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
[hidden] {
  display: none ;
}
.main {
  .titleIfo {
    width: 100%;
    height: 380px;
    background: url("./image/partners.jpg") no-repeat center center;
    background-size: cover;
    .container {
      h2 {
        padding-top: 180px;
        text-align: center;
        color: #ffffff;
        height: 42px;
        font-size: 32px;
        font-weight: bold;
        line-height: 42px;
      }
      h3 {
        text-align: center;
        height: 29px;
        font-size: 22px;
        line-height: 29px;
        color: #ffffff;
      }
    }
  }
  .partnersUsInfo {
    .container {
      border-top: 1px solid #e6e6e6;
      .content {
        margin-top: 30px;
        overflow: hidden;
        margin-bottom: 48px;
        .leftMenu {
          width: 246px;
          float: left;
          ul {
            li {
              padding: 0 16px;
              border-radius: 18px;
              height: 36px;
              overflow: hidden;
              line-height: 36px;
              margin-bottom: 10px;

              .a {
                display: block;
              }

              &:last-child {
                margin-bottom: 0;
              }

              i {
                display: inline-block;
                float: left;
                color: #252525;
                font-size: 16px;
              }

              b {
                display: inline-block;
                float: right;
                width: 30px;
                height: 100%;
                background: url("./image/yy2.png") no-repeat center center;
                background-size: 100%;
                line-height: 36px;
              }
            }

            .on {
              background: #13ae67;

              i {
                color: #ffffff;
              }

              b {
                background: url("./image/yy.png") no-repeat center center;
                background-size: 86%;
              }
            }
          }
        }
        .rightContent {
          float: right;
          margin-left: 88px;
          width: 866px;
          .titleNav {
            text-align: center;
            height: 40px;
            overflow: hidden;
            ul {
              display: inline-block;

              li {
                float: left;
                width: 190px;
                height: 38px;
                line-height: 38px;
                border: 1px solid #e0e0e0;
                font-size: 14px;
                color: #252525;
                margin-right: 24px;
                background-color: transparent;
                cursor: pointer;
                &:last-child {
                  margin-right: 0;
                }
              }
              .on {
                border: 1px solid #13ae67;
                color: #ffffff;
                background-color: #13ae67;
              }
            }
          }
          .logoList {
            margin-top: 50px;
            width: 100%;
            ul {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;
              li {
                cursor: pointer;
                width: 174px;
                border: 1px solid #fff;
                a {
                  color: black;
                  font-size: 15px;
                }
                &:hover {
                  border: 1px solid #13ae67;
                  border-radius: 4px;
                  div a {
                    color: #2db0ec;
                  }
                }
                overflow: hidden;
                text-align: center;
                padding: 20px;
                img {
                  width: 124px;
                  margin-bottom: 20px;
                }
                div {
                  margin-top: 10px;

                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
